// Import Swiper core and required modules
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const swiperContainer = document.querySelector('.staff .swiper');

    if (!swiperContainer) {
        return;
    }

    const staffSwiper = new Swiper(swiperContainer, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        speed: 800,
        navigation: {
            nextEl: '.staff .swiper-button-next',
            prevEl: '.staff .swiper-button-prev',
        },
        pagination: {
            el: '.staff .swiper-pagination',
            clickable: true,
        },
    });
});